import tw, { css } from 'twin.macro'

export const fieldsStyle = css`
  input:not([type='submit']),
  textarea,
  select {
    ${tw`rounded-none border outline-none hover:border-primary-2 focus:border-primary-2`}
  }

  input:not(type='submit'),
  select {
    ${tw`h-12 py-0`}
  }
`

const baseStyle = tw`
   relative
`

export default baseStyle
